import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { FormattedMessage, injectIntl } from 'react-intl';
import classNames from 'classnames';

import { GET_MODEL_LIST, INITIAL_PATH } from '../../../../config/consts';
import SeButton from '../../SeButton';
import Tooltip from '../../Tooltip';
import SeDropdownGroup from '../../SeDropdownGroup';
import { SeDropdownGrouped } from '../../SeDropdown';
import Mobile from '../../Responsive/Mobile';
import Desktop from '../../Responsive/Desktop';
import SeInput from '../../SeInput';
import { isLocal } from '../../../containers/App';
import styles from './index.scss';

const serialNumberImg = require('../../../../assets/images/serial_number.svg');
const modelNumberImg = require('../../../../assets/images/model_number.svg');

const REQUIRED_KEY_CODE = 'ATG_txtfield_required';
const INVALID_KEY_CODE = 'ATG_invalid_value';
const VOID = '';
const isAlphaNumeric = val => {
    const regexp = /^\w+([\w-]*\w)?$/gi;

    return regexp.test(val);
};
const isDigit = val => {
    const regexp = /^[0-9]+$/gi;

    return regexp.test(val);
};
const validateAlphaNumeric = val => {
    if (!val) {
        return REQUIRED_KEY_CODE;
    }

    if (!isAlphaNumeric(val)) {
        return INVALID_KEY_CODE;
    }

    return VOID;
};
const validateDigit = val => {
    if (!val) {
        return REQUIRED_KEY_CODE;
    }

    if (!isDigit(val)) {
        return INVALID_KEY_CODE;
    }

    return VOID;
};
const checkValidatedState = stateToCheck => {
    const arr = Object.values(stateToCheck);

    return arr.every(item => item === VOID);
};

class AddUPSForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            upsManufactureDDValue: '',
            isModelDDLoading: true,
            upsManufactureValue: '',
            modelValue: '',
            modelList: [],
            upsCapacity: '',
            upsWeight: '0',
            modelsDDList: [],
            serialNumber: '',

            APCInputsErrorSet: {
                manufacturerError: '',
                modelSKUError: '',
                serialNumError: '',
            },
            otherInputsErrorSet: {
                manufacturerError: '',
                modelSKUError: '',
                serialNumError: '',
                capacityError: '',
            },
        };
    }

    componentDidMount() {
        this.getModelList();
    }

    /**
     *
     * @param id
     */
    onManufactureDropdownChange = id => {
        if (id === 'APC') {
            this.setState({
                upsManufactureFlag: '1',
                upsManufactureDDValue: id,
                upsManufactureValue: id,
                upsManufactureDisplayValue: id,
                modelValue: '',
                upsCapacity: '',
                serialNumber: '',
                APCInputsErrorSet: {},
                otherInputsErrorSet: {},
                upsWeight: '0',
            });

            this.getModelDDList();
        } else {
            this.setState({
                upsManufactureDDValue: 'Other',
                upsManufactureDisplayValue: id,
                upsManufactureFlag: '0',
                upsManufactureValue: '',
                upsWeight: '0',
                modelValue: '',
                upsCapacity: '',
                serialNumber: '',
                otherInputsErrorSet: {},
                APCInputsErrorSet: {},
            });
        }
    };

    /**
     *
     * @param id
     */
    onModelDropdownChange = id => {
        this.setState({
            modelValue: id,
        });
        this.fillCapacityWeight(id);
    };

    /**
     *
     * @param upsItem
     */
    fillCapacityWeight = upsItem => {
        const { modelList } = this.state;
        const objArray = modelList.filter(obj => obj.item === upsItem);

        if (objArray) {
            objArray.map((item, index) =>
                this.setState({
                    upsCapacity: item.capacity,
                    upsWeight: item.weight,
                }),
            );
        }
    };

    /**
     *
     */
    getModelDDList() {
        const { modelList } = this.state;
        const modelDDList = modelList.map((item, index) => item.item);
        this.setState({
            modelsDDList: modelDDList,
            isModelDDLoading: false,
        });
    }

    /**
     *
     */
    getModelList() {
        const locationArr = window.location.href.split('/');
        const countryCode = locationArr[5];
        const languageCode = locationArr[6];
        const URL = `${INITIAL_PATH}${countryCode}/${languageCode}${GET_MODEL_LIST}`;

        axios
            .post(isLocal() ? 'http://localhost:3000/api/v1/tradeUpData' : URL, {})
            .then(result => {
                this.setState({
                    modelList: result.data,
                });
            })
            .catch(err => {
                console.log(err);
            });
    }

    validateDDManufacturer() {
        const { upsManufactureDDValue } = this.state;

        if (!upsManufactureDDValue) {
            return REQUIRED_KEY_CODE;
        }

        return VOID;
    }

    validateManufacturer() {
        const { upsManufactureValue } = this.state;

        if (!upsManufactureValue) {
            return REQUIRED_KEY_CODE;
        }

        return isAlphaNumeric(upsManufactureValue) ? VOID : INVALID_KEY_CODE;
    }

    getValidatedAPCInputsState() {
        const { modelValue, serialNumber } = this.state;
        const validatedManufacturer = this.validateDDManufacturer();
        const validatedModelSKU = validateAlphaNumeric(modelValue);
        const validatedSerialNum = validateAlphaNumeric(serialNumber);

        return {
            manufacturerError: validatedManufacturer,
            modelSKUError: validatedModelSKU,
            serialNumError: validatedSerialNum,
        };
    }

    getValidatedOtherInputsState() {
        const { modelValue, serialNumber, upsCapacity } = this.state;
        const validatedManufacturer = this.validateManufacturer('otherInputsErrorSet');
        const validatedModelSKU = validateAlphaNumeric(modelValue);
        const validatedSerialNum = validateAlphaNumeric(serialNumber);
        const validatedCapacity = validateDigit(upsCapacity);

        return {
            manufacturerError: validatedManufacturer,
            modelSKUError: validatedModelSKU,
            serialNumError: validatedSerialNum,
            capacityError: validatedCapacity,
        };
    }

    /**
     * Handles 'Add button' clicking
     */
    handleAddUps = () => {
        const {
            upsManufactureValue,
            modelValue,
            serialNumber,
            upsCapacity,
            upsWeight,
            upsManufactureFlag,
        } = this.state;

        const validatedAPCInputsState = this.getValidatedAPCInputsState();
        const validatedOtherInputsState = this.getValidatedOtherInputsState();
        const isValidAPCInputsState = checkValidatedState(validatedAPCInputsState);
        const isValidOtherInputsState = checkValidatedState(validatedOtherInputsState);

        if (isValidAPCInputsState && isValidOtherInputsState) {
            const newUps = [
                upsManufactureValue,
                modelValue,
                serialNumber,
                upsCapacity.toString(),
                upsWeight.toString(),
                upsManufactureFlag,
            ];

            this.props.addUps(newUps);

            this.setState({
                ...this.state,
                upsManufactureDDValue: '',
                upsManufactureValue: '',
                modelValue: '',
                serialNumber: '',
                upsCapacity: '',
                upsWeight: '0',
                upsManufactureFlag: '',
                upsManufactureDisplayValue: '',

                APCInputsErrorSet: {
                    manufacturerError: '',
                    modelSKUError: '',
                    serialNumError: '',
                },
                otherInputsErrorSet: {
                    manufacturerError: '',
                    modelSKUError: '',
                    serialNumError: '',
                    capacityError: '',
                },
            });
        } else {
            this.setState({
                ...this.state,
                APCInputsErrorSet: { ...validatedAPCInputsState },
                otherInputsErrorSet: { ...validatedOtherInputsState },
            });
        }
    };

    /**
     *
     * @param value
     */
    handleManufactireInput = value => {
        this.setState({
            ...this.state,
            upsManufactureValue: value,
        });
    };

    /**
     *
     * @param value
     */
    handleSerialNumberChange = value => {
        this.setState({
            ...this.state,
            serialNumber: value,
        });
    };

    /**
     *
     * @param value
     */
    handleModelInput = value => {
        this.setState({
            ...this.state,
            modelValue: value,
        });
    };

    /**
     *
     * @param value
     */
    handleCapacityInput = value => {
        this.setState(() => ({
            ...this.state,
            upsCapacity: value,
        }));
        this.updateWeightValue(value);
    };

    /**
     *
     * @param value
     */
    updateWeightValue = value => {
        if (!isNaN(value)) {
            const weight = (value * 0.037).toFixed(2);
            this.setState(() => ({
                upsWeight: weight === '0' ? 0 : weight,
            }));
        }
    };
    renderOtherFormFields = () => {
        const { modelValue, upsCapacity, upsWeight } = this.state;
        const populatedFieldsColor = classNames({
            [styles.calculatedValue]: modelValue !== '',
            [styles.defaultedValue]: modelValue === '',
        });
        const otherOptionRow = classNames({
            [styles.upsListTableRow]: true,
            [styles.upsListTableRowOther]: true,
        });
        return (
            <React.Fragment>
                <div className={otherOptionRow}>
                    <div
                        className={`${styles.upsListTableCellBig} ${styles.upsListTableCell}
                ${styles.upsListTableInputCell}`}
                    >
                        <SeInput
                            block
                            onChange={this.handleManufactireInput}
                            value={this.state.upsManufactureValue}
                            defaultValue={''}
                            maxLength={30}
                            extraClass={this.state.otherInputsErrorSet.manufacturerError ? 'is-invalid' : ''}
                        />
                    </div>
                    <div
                        className={`${styles.upsListTableCellBig} ${styles.upsListTableCell} ${
                            styles.upsListTableInputCell
                        }`}
                    >
                        <SeInput
                            block
                            onChange={this.handleModelInput}
                            value={this.state.modelValue}
                            defaultValue={''}
                            maxLength={30}
                            extraClass={this.state.otherInputsErrorSet.modelSKUError ? 'is-invalid' : ''}
                        />
                    </div>
                    <div
                        className={`${styles.upsListTableCellBig} ${styles.upsListTableCell} ${
                            styles.upsListTableInputCell
                        }`}
                    >
                        <SeInput
                            block
                            onChange={this.handleSerialNumberChange}
                            value={this.state.serialNumber}
                            defaultValue={''}
                            maxLength={30}
                            extraClass={this.state.otherInputsErrorSet.serialNumError ? 'is-invalid' : ''}
                        />
                    </div>
                    <div
                        className={`${styles.upsListTableCellMiddle} ${styles.upsListTableCell} ${
                            styles.upsListTableInputCell
                        }`}
                    >
                        <div className={populatedFieldsColor}>
                            <SeInput
                                block
                                onChange={this.handleCapacityInput}
                                value={upsCapacity !== '0' ? upsCapacity : ''}
                                defaultValue={''}
                                maxLength={20}
                                extraClass={this.state.otherInputsErrorSet.capacityError ? 'is-invalid' : ''}
                            />
                        </div>
                    </div>
                    <div
                        className={`${styles.upsListTableCellMiddle} ${styles.upsListTableCell} ${
                            styles.upsListTableInputCell
                        } ${styles.wrappedOption}`}
                    >
                        <div className={populatedFieldsColor}> {upsWeight} </div>
                    </div>
                    <div className={`${styles.upsListTableCellSmall} ${styles.upsListTableCell} analytics-add`}>
                        <SeButton disabled={false} onClick={this.handleAddUps} secondary={true}>
                            <FormattedMessage id={'Keyword_add'} />
                        </SeButton>
                    </div>
                </div>
            </React.Fragment>
        );
    };
    renderAPCFormFields = () => {
        const {
            modelValue,
            upsManufactureDDValue,
            isModelDDLoading,
            upsCapacity,
            upsWeight,
            modelsDDList,
            upsManufactureFlag,
        } = this.state;

        const populatedFieldsColor = classNames({
            [styles.calculatedValue]: modelValue !== '',
            [styles.defaultedValue]: modelValue === '',
        });

        return (
            <React.Fragment>
                <div
                    className={`${styles.upsListTableCellBig} ${styles.upsListTableCell} ${
                        styles.upsListTableInputCell
                    }`}
                >
                    <SeDropdownGrouped
                        searchInputProps={{ id: 'device-dropdown' }}
                        items={modelsDDList}
                        isLoading={upsManufactureDDValue === '' && isModelDDLoading && upsManufactureFlag === '1'}
                        value={modelValue}
                        onChange={this.onModelDropdownChange}
                        dropdownPlaceholderKey="tradeUps_typeOrSelect"
                        placeholder="tradeUps_typeOrSelect"
                        disabled={upsManufactureDDValue === ''}
                        extraClass={this.state.APCInputsErrorSet.modelSKUError ? 'is-invalid' : ''}
                    />
                </div>
                <div
                    className={`${styles.upsListTableCellBig} ${styles.upsListTableCell} ${
                        styles.upsListTableInputCell
                    }`}
                >
                    <SeInput
                        block
                        onChange={this.handleSerialNumberChange}
                        value={this.state.serialNumber}
                        defaultValue={''}
                        maxLength={30}
                        extraClass={this.state.APCInputsErrorSet.serialNumError ? 'is-invalid' : ''}
                    />
                </div>
                <div
                    className={`${styles.upsListTableCellMiddle} ${styles.upsListTableCell} ${
                        styles.upsListTableInputCell
                    }`}
                >
                    <div className={populatedFieldsColor}> {upsCapacity === '' ? '0' : upsCapacity} </div>
                </div>
                <div
                    className={`${styles.upsListTableCellMiddle} ${styles.upsListTableCell} ${
                        styles.upsListTableInputCell
                    } `}
                >
                    <div className={populatedFieldsColor}> {upsWeight} </div>
                </div>
                <div className={`${styles.upsListTableCellSmall} ${styles.upsListTableCell} analytics-add`}>
                    <SeButton disabled={false} onClick={this.handleAddUps} secondary={true}>
                        <FormattedMessage id={'Keyword_add'} />
                    </SeButton>
                </div>
            </React.Fragment>
        );
    };
    renderErrors = () => {
        const { upsManufactureDDValue } = this.state;
        if (upsManufactureDDValue !== 'Other') {
            return (
                <React.Fragment>
                    <div className={styles.upsListTableRow}>
                        <div
                            className={`${styles.upsListTableCellBig} ${styles.upsListTableCellError} ${
                                styles.upsListTableInputCell
                            }`}
                        >
                            {this.state.APCInputsErrorSet.manufacturerError ? (
                                <div className="invalid-feedback">
                                    <FormattedMessage id={this.state.APCInputsErrorSet.manufacturerError} />
                                </div>
                            ) : null}
                        </div>
                        <div
                            className={`${styles.upsListTableCellBig} ${styles.upsListTableCellError}
                ${styles.upsListTableInputCell}`}
                        >
                            {this.state.APCInputsErrorSet.modelSKUError ? (
                                <div className="invalid-feedback">
                                    <FormattedMessage id={this.state.APCInputsErrorSet.modelSKUError} />
                                </div>
                            ) : null}
                        </div>

                        <div
                            className={`${styles.upsListTableCellBig} ${styles.upsListTableCellError}
                ${styles.upsListTableInputCell}`}
                        >
                            {this.state.APCInputsErrorSet.serialNumError ? (
                                <div className="invalid-feedback">
                                    <FormattedMessage id={this.state.APCInputsErrorSet.serialNumError} />
                                </div>
                            ) : null}
                        </div>
                        <div
                            className={`${styles.upsListTableCellBig} ${styles.upsListTableCellError}  ${
                                styles.upsListTableCellMiddle
                            }
                ${styles.upsListTableInputCell}`}
                        />

                        <div
                            className={`${styles.upsListTableCellMiddle} ${styles.upsListTableCellError}
                ${styles.upsListTableInputCell}`}
                        />
                        <div
                            className={`${styles.upsListTableCellBig} ${styles.upsListTableCellError}
                ${styles.upsListTableInputCell}`}
                        />
                    </div>
                </React.Fragment>
            );
        }
        return (
            <React.Fragment>
                <div className={styles.upsListTableRow}>
                    <div
                        className={`${styles.upsListTableCellBig} ${styles.upsListTableCellError}
    ${styles.upsListTableInputCell}`}
                    >
                        {this.state.otherInputsErrorSet.manufacturerError ? (
                            <div className="invalid-feedback">
                                <FormattedMessage id={this.state.otherInputsErrorSet.manufacturerError} />
                            </div>
                        ) : null}
                    </div>

                    <div
                        className={`${styles.upsListTableCellBig} ${styles.upsListTableCellError}
    ${styles.upsListTableInputCell}`}
                    >
                        {this.state.otherInputsErrorSet.modelSKUError ? (
                            <div className="invalid-feedback">
                                <FormattedMessage id={this.state.otherInputsErrorSet.modelSKUError} />
                            </div>
                        ) : null}
                    </div>

                    <div
                        className={`${styles.upsListTableCellBig} ${styles.upsListTableCellError}
    ${styles.upsListTableInputCell}`}
                    >
                        {this.state.otherInputsErrorSet.serialNumError ? (
                            <div className="invalid-feedback">
                                <FormattedMessage id={this.state.otherInputsErrorSet.serialNumError} />
                            </div>
                        ) : null}
                    </div>

                    <div
                        className={`${styles.upsListTableCellBig} ${styles.upsListTableCellError}  ${
                            styles.upsListTableCellMiddle
                        }
    ${styles.upsListTableInputCell}`}
                    >
                        {this.state.otherInputsErrorSet.capacityError ? (
                            <div className="invalid-feedback">
                                <FormattedMessage id={this.state.otherInputsErrorSet.capacityError} />
                            </div>
                        ) : null}
                    </div>

                    <div
                        className={`${styles.upsListTableCellMiddle} ${styles.upsListTableCellError}
    ${styles.upsListTableInputCell}`}
                    />

                    <div
                        className={`${styles.upsListTableCellBig} ${styles.upsListTableCellError}
    ${styles.upsListTableInputCell}`}
                    />
                </div>
            </React.Fragment>
        );
    };

    /**
     * Renders component
     * @returns {*}
     */
    render() {
        const {
            modelValue,
            upsManufactureDDValue,
            upsManufactureDisplayValue,
            upsManufactureValue,
            upsCapacity,
            upsWeight,
            modelsDDList,
            isModelDDLoading,
            upsManufactureFlag,
        } = this.state;
        const { hideFormLabels } = this.props;
        const formClasses = classNames({
            [styles.upsListTable]: true,
            [styles.upsListForm]: hideFormLabels,
        });

        const displayOtherOption = classNames({
            [styles.otherOption]: upsManufactureDDValue === 'Other',
        });
        const formLabels = classNames({
            [styles.upsListTableRow]: true,
            [styles.hidden]: hideFormLabels,
            [styles.upsListTableRowForm]: true,
        });
        const isOnlyForm = classNames({
            [styles.firstRowForm]: !hideFormLabels,
            [styles.upsListTableRow]: true,
            [styles.upsListTableRowForm]: true,
        });
        const { formatMessage } = this.props.intl;
        const localizedOtherValue = formatMessage({ id: 'keyword_Other' });

        return (
            <SeDropdownGroup>
                {/* ------------------------ DESKTOP ------------------------ */}
                <Desktop>
                    <div className={formLabels}>
                        {/* UPS Manufacturer cell */}
                        <div className={`${styles.upsListTableCell} ${styles.upsListTableCellBig}`}>
                            <label className={styles.formGroupLabel}>
                                <FormattedMessage id={'tradeUps_upsManufacturer'} />
                            </label>
                        </div>
                        {/* Model SKU cell */}
                        <div className={`${styles.upsListTableCell} ${styles.upsListTableCellBig}`}>
                            <label className={styles.formGroupLabel}>
                                <FormattedMessage id="tradeUps_modelSku" />
                                <Tooltip
                                    extraClass="m-l-5"
                                    delayTime={500}
                                    tooltipImagePath={modelNumberImg}
                                    tooltipMobileHeader=""
                                    tooltipText="tradeUps_tooltipModelNumber"
                                />
                            </label>
                        </div>
                        {/* Serial No. cell */}
                        <div className={`${styles.upsListTableCell} ${styles.upsListTableCellBig}`}>
                            <label className={styles.formGroupLabel}>
                                <FormattedMessage id="tradeUps_serialNo" />
                                <Tooltip
                                    extraClass="m-l-5"
                                    delayTime={500}
                                    tooltipImagePath={serialNumberImg}
                                    tooltipMobileHeader=""
                                    tooltipText="tradeUps_tooltipSerialNumber"
                                />
                            </label>
                        </div>
                        {/* Capacity cell */}
                        <div className={`${styles.upsListTableCell} ${styles.upsListTableCellMiddle}`}>
                            <label className={styles.formGroupLabel}>
                                <FormattedMessage id="tradeUps_capacity" />
                            </label>
                        </div>
                        {/* Weight cell */}
                        <div className={`${styles.upsListTableCell} ${styles.upsListTableCellMiddle}`}>
                            <label className={styles.formGroupLabel}>
                                <FormattedMessage id="tradeUps_weight" />
                            </label>
                        </div>
                        {/* Remove cell */}
                        <div className={`${styles.upsListTableCell} ${styles.upsListTableCellSmall}`}>
                            <label className={styles.formGroupLabel} />
                        </div>
                    </div>
                    <div className={isOnlyForm}>
                        <div
                            className={`${styles.upsListTableCellBig}
                                ${styles.upsListTableCell}
                                ${styles.upsListTableInputCell}
                                ${displayOtherOption}`}
                        >
                            <SeDropdownGrouped
                                items={['APC', localizedOtherValue]}
                                onChange={this.onManufactureDropdownChange}
                                value={upsManufactureDisplayValue}
                                size="small"
                                placeholder="keyword_selectManufacturer"
                                extraClass={this.state.APCInputsErrorSet.manufacturerError ? 'is-invalid' : ''}
                                withoutSorting={true}
                            />
                        </div>
                        {upsManufactureDDValue !== 'Other' ? this.renderAPCFormFields() : null}
                    </div>
                    {upsManufactureDDValue === 'Other' ? this.renderOtherFormFields() : null}

                    {this.renderErrors()}
                </Desktop>
                {/* ------------------------ MOBILE ------------------------ */}
                <Mobile>
                    <div className={formClasses}>
                        <div className={`${styles.mobileFormGroup}`}>
                            <label className={styles.formGroupLabel}>
                                <FormattedMessage id={'tradeUps_upsManufacturer'} />
                            </label>
                            <SeDropdownGrouped
                                items={['APC', localizedOtherValue]}
                                onChange={this.onManufactureDropdownChange}
                                value={upsManufactureDisplayValue}
                                size="small"
                                placeholder="keyword_selectManufacturer"
                                extraClass={this.state.APCInputsErrorSet.manufacturerError ? 'is-invalid' : ''}
                                withoutSorting={true}
                            />
                            {this.state.APCInputsErrorSet.manufacturerError ? (
                                <div className="invalid-feedback">
                                    <FormattedMessage id={this.state.APCInputsErrorSet.manufacturerError} />
                                </div>
                            ) : null}
                        </div>

                        {upsManufactureDDValue !== 'Other' ? (
                            <div>
                                <div className={styles.mobileFormGroup}>
                                    <label className={styles.formGroupLabel}>
                                        <FormattedMessage id={'tradeUps_modelSku'} />
                                        <Tooltip
                                            extraClass="m-l-5"
                                            delayTime={500}
                                            tooltipImagePath={modelNumberImg}
                                            tooltipMobileHeader={``}
                                            tooltipText="tradeUps_tooltipModelNumber"
                                        />
                                    </label>
                                    <SeDropdownGrouped
                                        searchInputProps={{ id: 'device-dropdown' }}
                                        items={modelsDDList}
                                        isLoading={
                                            upsManufactureDDValue === '' &&
                                            isModelDDLoading &&
                                            upsManufactureFlag === '1'
                                        }
                                        value={modelValue}
                                        onChange={this.onModelDropdownChange}
                                        dropdownPlaceholderKey="tradeUps_typeOrSelect"
                                        placeholder="tradeUps_typeOrSelect"
                                        disabled={upsManufactureDDValue === ''}
                                        extraClass={this.state.APCInputsErrorSet.modelSKUError ? 'is-invalid' : ''}
                                    />
                                    {this.state.APCInputsErrorSet.modelSKUError ? (
                                        <div className="invalid-feedback">
                                            <FormattedMessage id={this.state.APCInputsErrorSet.modelSKUError} />
                                        </div>
                                    ) : null}
                                </div>
                                <div className={styles.mobileFormGroup}>
                                    <label className={styles.formGroupLabel}>
                                        <FormattedMessage id={'tradeUps_serialNo'} />
                                        <Tooltip
                                            extraClass="m-l-5"
                                            delayTime={500}
                                            tooltipImagePath={serialNumberImg}
                                            tooltipMobileHeader={`upss_why_power_draw_in_watts__`}
                                            tooltipText="tradeUps_tooltipSerialNumber"
                                        />
                                    </label>
                                    <SeInput
                                        block
                                        onChange={this.handleSerialNumberChange}
                                        value={this.state.serialNumber}
                                        defaultValue={''}
                                        maxLength={30}
                                        extraClass={this.state.APCInputsErrorSet.serialNumError ? 'is-invalid' : ''}
                                    />
                                    {this.state.APCInputsErrorSet.serialNumError ? (
                                        <div className="invalid-feedback">
                                            <FormattedMessage id={this.state.APCInputsErrorSet.serialNumError} />
                                        </div>
                                    ) : null}
                                </div>
                                <div className={styles.flexBlock}>
                                    <div className={`${styles.mobileFormGroup} ${styles.capacityBlock}`}>
                                        <label className={styles.formGroupLabel}>
                                            <FormattedMessage id={'tradeUps_capacity'} />
                                        </label>
                                        <div>{upsCapacity === '' ? '0' : upsCapacity}</div>
                                    </div>
                                    <div className={styles.mobileFormGroup}>
                                        <label className={styles.formGroupLabel}>
                                            <FormattedMessage id={'tradeUps_weight'} />
                                        </label>
                                        <div>{upsWeight}</div>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        {upsManufactureDDValue === 'Other' ? (
                            <div>
                                <div className={styles.mobileFormGroup}>
                                    <SeInput
                                        block
                                        onChange={this.handleManufactireInput}
                                        defaultValue={''}
                                        maxLength={30}
                                        extraClass={
                                            this.state.otherInputsErrorSet.manufacturerError ? 'is-invalid' : ''
                                        }
                                    />
                                    {this.state.otherInputsErrorSet.manufacturerError ? (
                                        <div className="invalid-feedback">
                                            <FormattedMessage id={this.state.otherInputsErrorSet.manufacturerError} />
                                        </div>
                                    ) : null}
                                </div>
                                <div className={styles.mobileFormGroup}>
                                    <label className={styles.formGroupLabel}>
                                        <FormattedMessage id={'tradeUps_modelSku'} />
                                        <Tooltip
                                            extraClass="m-l-5"
                                            delayTime={500}
                                            tooltipImagePath={modelNumberImg}
                                            tooltipMobileHeader={``}
                                            tooltipText="tradeUps_tooltipModelNumber"
                                        />
                                    </label>
                                    <SeInput
                                        block
                                        onChange={this.handleModelInput}
                                        defaultValue={''}
                                        maxLength={30}
                                        extraClass={this.state.otherInputsErrorSet.modelSKUError ? 'is-invalid' : ''}
                                    />
                                    {this.state.otherInputsErrorSet.modelSKUError ? (
                                        <div className="invalid-feedback">
                                            <FormattedMessage id={this.state.otherInputsErrorSet.modelSKUError} />
                                        </div>
                                    ) : null}
                                </div>
                                <div className={styles.mobileFormGroup}>
                                    <label className={styles.formGroupLabel}>
                                        <FormattedMessage id={'tradeUps_serialNo'} />
                                        <Tooltip
                                            extraClass="m-l-5"
                                            delayTime={500}
                                            tooltipImagePath={serialNumberImg}
                                            tooltipMobileHeader={``}
                                            tooltipText="tradeUps_tooltipSerialNumber"
                                        />
                                    </label>
                                    <SeInput
                                        block
                                        onChange={this.handleSerialNumberChange}
                                        defaultValue={''}
                                        maxLength={30}
                                        extraClass={this.state.otherInputsErrorSet.serialNumError ? 'is-invalid' : ''}
                                    />
                                    {this.state.otherInputsErrorSet.serialNumError ? (
                                        <div className="invalid-feedback">
                                            <FormattedMessage id={this.state.otherInputsErrorSet.serialNumError} />
                                        </div>
                                    ) : null}
                                </div>
                                <div className={styles.flexBlock}>
                                    <div className={`${styles.mobileFormGroup} ${styles.capacityBlock}`}>
                                        <label className={styles.formGroupLabel}>
                                            <FormattedMessage id={'tradeUps_capacity'} />
                                        </label>
                                        <div>
                                            <SeInput
                                                block
                                                onChange={this.handleCapacityInput}
                                                defaultValue={''}
                                                value={upsCapacity !== '0' ? upsCapacity : ''}
                                                maxLength={20}
                                                extraClass={
                                                    this.state.otherInputsErrorSet.capacityError ? 'is-invalid' : ''
                                                }
                                            />
                                            {this.state.otherInputsErrorSet.capacityError ? (
                                                <div className="invalid-feedback">
                                                    <FormattedMessage
                                                        id={this.state.otherInputsErrorSet.capacityError}
                                                    />
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                    <div className={`${styles.mobileFormGroup} ${styles.otherWeightOption}`}>
                                        <label className={styles.formGroupLabel}>
                                            <FormattedMessage id={'tradeUps_weight'} />
                                        </label>
                                        <div className={styles.otherWeightValue}>{upsWeight}</div>
                                    </div>
                                </div>
                            </div>
                        ) : null}
                        <SeButton
                            disabled={false}
                            onClick={this.handleAddUps}
                            secondary={true}
                            extraClass={'analytics-add'}
                        >
                            <FormattedMessage id={'Keyword_add'} />
                        </SeButton>
                    </div>
                </Mobile>
            </SeDropdownGroup>
        );
    }
}

AddUPSForm.propTypes = {
    hideFormLabels: PropTypes.bool.isRequired,
    addUps: PropTypes.func.isRequired,
    intl: PropTypes.shape({
        formatMessage: PropTypes.func.isRequired,
    }).isRequired,
};

export default injectIntl(AddUPSForm);
